import { useRoute } from '#imports'

export function useRouteLocalizedPath() {
    const route = useRoute()

    return (rawPath: string) => {
        if (
            !rawPath ||
            /^(?:[a-z]+:)?\/\//i.test(rawPath) ||
            rawPath.startsWith('#')
        ) {
            return rawPath
        }

        const match = rawPath.match(/^([^?#]*)(.*)$/)
        const pathname = match?.[1] || '/'
        const suffix = match?.[2] || ''
        const normalizedPath =
            pathname.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/'
        const routeLocale = route.path.match(
            /^\/([a-z]{2})(?=\/|$)/i
        )?.[1]

        if (!routeLocale || routeLocale === 'en') {
            return `${normalizedPath}${suffix}`
        }
        if (normalizedPath === '/') {
            return `/${routeLocale}${suffix}`
        }
        return `/${routeLocale}${normalizedPath}${suffix}`
    }
}
